import { createColumnHelper } from "@tanstack/react-table";
import eyeIcon from '../../../assets/images/eye.svg'
const columnHelper = createColumnHelper();

const PartnerProfileColumnDefDefaultFnC = (navigateCallback, t) => [
  {
    accessorKey: 'companyName',
    header: 'Company Name'
  },
  {
    accessorKey: 'companyTypeName',
    header: 'Company Type'
  },

  {
    accessorKey: 'country',
    header: 'Country'
  },
  {
    accessorKey: 'emailAddress',
    header: 'Email'
  },
  {
    accessorKey: 'phoneNumber',
    header: "Phone"
  },
  {
    accessorKey: 'action',
    header: 'Action',
    cell: ({ row }) => {
      return (
        <div className="d-flex clays-sm">
          <button class="icon-clay" onClick={() => navigateCallback(row.original.companyId, 'view')}>
            <span class="inner-clay color-black"><img src={eyeIcon} alt="view" /></span>
          </button>
        </div>)
    }
  },
]
export { PartnerProfileColumnDefDefaultFnC }
